import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    SAVE_APPOINTMENT,
    saveAppointmentFail,
    saveAppointmentSuccess
} from '../action/saveAppointmentAction'

// api 
import saveAppointmentApi from '../api/saveAppointmentApi'

export function* saveAppointmentSaga(action) {
    try {
        const response = yield call(() => saveAppointmentApi(action.params))
        if (response.data.status === 1) {
            yield put(saveAppointmentSuccess(response, action))
        } else {
            yield put(saveAppointmentFail(response, action))
        }
    }
    catch (e) {
        yield put(saveAppointmentFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(SAVE_APPOINTMENT, saveAppointmentSaga)
}